export const SelectInputDropdownClass = "SelectInputDropDownV5";
export const SelectInputStyledClass = "SelectInputStyled";
